import { Trans } from '@lingui/react/macro';

import AlertBar from '@/design_system/AlertBar';
import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import IconComment from '@/icons/Comment.svg';
import IconItemDelete from '@/icons/ItemDelete.svg';
import { ArticleWithRelations } from '@/models/request';

const RequalificationComment = ({ article }: { article: ArticleWithRelations }) => {
  if (!article.requalificationComment && !article.requalificationAnalysisComment) {
    return null;
  }

  return (
    <Stack gap="0.5rem">
      {!!article.requalificationComment && (
        <AlertBar
          type="info"
          size="large"
          icon={<IconComment />}
          title={
            <Paragraph>
              <Trans id="article.requalification-comment">New quote comment</Trans>
            </Paragraph>
          }
        >
          <Paragraph>&quot;{article.requalificationComment}&quot;</Paragraph>
        </AlertBar>
      )}
      {!!article.requalificationAnalysisComment && (
        <AlertBar
          icon={<IconItemDelete />}
          type="error"
          size="large"
          title={
            <Paragraph>
              <Trans id="article.requalification-comment.after-sales">
                New quote refusal reason
              </Trans>
            </Paragraph>
          }
        >
          <Paragraph>&quot;{article.requalificationAnalysisComment}&quot;</Paragraph>
        </AlertBar>
      )}
    </Stack>
  );
};

export default RequalificationComment;
